import React, { useState } from 'react';
import { API_DOMAIN } from './globals'; // Import the global domain name

function ChangePasswordAFL() {
    const UserType = sessionStorage.getItem("UserType");
    const UserName = sessionStorage.getItem("UserName");

    const [passwordData, setPasswordData] = useState({
        oldpassword: '',
        password: '',
        confirmpassword: '',
        UserName: UserName, // Corrected assignment
        UserType: UserType, // Corrected assignment
    });

    const [errorMsg, setErrorMsg] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPasswordData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleReset = () => {
        setPasswordData({
            oldpassword: '',
            password: '',
            confirmpassword: '',
            UserName: UserName,
            UserType: UserType,
        });
        setErrorMsg('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (passwordData.password !== passwordData.confirmpassword) {
            setErrorMsg("Confirm Password doesn't match");
        } else if (passwordData.oldpassword === passwordData.password) {
            setErrorMsg('Old Password and New Password must not be the same');
        } else {
            setErrorMsg('');
            try {
                const response = await fetch(`${API_DOMAIN}/api/Client/ChangePasswordAFL.php`, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(passwordData),
                });

                const data = await response.json();
                console.log(data.Status);
                
                if (data.Status == 'Success') {
                    window.location = '/';
                } else if(data.Status=="Error1") {
                    sessionStorage.setItem("LogoutMsg",data.Message)
                    window.location = '/';
                } else {
                    setErrorMsg(data.Message);
                }
            } catch (error) {
                console.error('Error:', error);
                setErrorMsg('An error occurred while changing the password.');
            }
        }
    };

    return (
        <section className="match-content">
            <div className="table_tittle" style={{ display: 'flex', justifyContent: 'space-between',background: 'linear-gradient(to right, #622569, #d54be4)',color:'white' }}>
                Change Password
                {errorMsg && <div style={{ color: 'red' }}>{errorMsg}</div>}
            </div>
            <div className="clearfix data-background">
                <form onSubmit={handleSubmit}>
                    <div className="col-md-12 form-horizontal row form-label-left input_mask">
                        <div className="col-md-4 col-xs-6">
                            <label className="pwdlable">
                                Old Password <span className="required">*</span>
                            </label>
                            <input
                                type="password"
                                name="oldpassword"
                                className="form-control"
                                value={passwordData.oldpassword}
                                onChange={handleChange}
                                placeholder="Old Password"
                                required
                            />
                        </div>
                        <div className="col-md-4 col-xs-6">
                            <label className="pwdlable">
                                New Password <span className="required">*</span>
                            </label>
                            <input
                                type="password"
                                name="password" // Fixed name
                                className="form-control"
                                value={passwordData.password}
                                onChange={handleChange}
                                placeholder="New Password"
                                required
                            />
                        </div>
                        <div className="col-md-4 col-xs-6">
                            <label className="pwdlable">
                                Retype New Password <span className="required">*</span>
                            </label>
                            <input
                                type="password"
                                name="confirmpassword"
                                className="form-control"
                                value={passwordData.confirmpassword}
                                onChange={handleChange}
                                placeholder="Confirm New Password"
                                required
                            />
                        </div>
                        <div className="col-md-4 btn-bethistory-filter col-xs-12">
                            <div className="col-md-12 col-xs-12">
                                <button type="button" className="btn btn-primary resetPassword-button" onClick={handleReset}>
                                    Reset
                                </button>
                                <button type="submit" className="btn btn-primary resetPassword-button">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </section>
    );
}

export default ChangePasswordAFL;
